<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<div-->
            <!--v-if="created"-->
            <!--class="alert alert-success"-->
            <!--role="status">{{ created['brandTitle'] }} {{$t('notifications.created')}}</div>-->
          <!--<div-->
            <!--v-if="updated"-->
            <!--class="alert alert-success"-->
            <!--role="status">{{ updated['brandTitle'] }} {{$t('notifications.updated')}}</div>-->
          <!--<div-->
            <!--v-if="isLoading || deleteLoading"-->
            <!--class="alert alert-info"-->
            <!--role="status">{{$t('alerts.loading')}}...</div>-->
          <!--<div-->
            <!--v-if="error"-->
            <!--class="alert alert-danger"-->
            <!--role="alert">-->
        <!--<span-->
          <!--class="fa fa-exclamation-triangle"-->
          <!--aria-hidden="true"></span> {{ error }}-->
          <!--</div>-->
          <!--<div-->
            <!--v-if="deleteError"-->
            <!--class="alert alert-danger"-->
            <!--role="alert">-->
        <!--<span-->
          <!--class="fa fa-exclamation-triangle"-->
          <!--aria-hidden="true"></span> {{ deleteError }}-->
          <!--</div>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMDeviceTypeList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-card-title>{{$t('views.excmdevicetype.update.title')}}  {{ item && item['title'] }}</b-card-title>
            <EXCMDeviceTypeForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDeviceTypeForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMDeviceTypeForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceTypeUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdevicetype/update/isLoading',
      error: 'excmdevicetype/update/error',
      deleteError: 'excmdevicetype/del/error',
      deleteLoading: 'excmdevicetype/del/isLoading',
      created: 'excmdevicetype/create/created',
      deleted: 'excmdevicetype/del/deleted',
      retrieved: 'excmdevicetype/update/retrieved',
      updated: 'excmdevicetype/update/updated',
      violations: 'excmdevicetype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDeviceTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdevicetype/create/reset',
      deleteItem: 'excmdevicetype/del/del',
      delReset: 'excmdevicetype/del/reset',
      retrieve: 'excmdevicetype/update/retrieve',
      updateReset: 'excmdevicetype/update/reset',
      update: 'excmdevicetype/update/update',
      updateRetrieved: 'excmdevicetype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdevicetype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
